export const labels = {
    loginHeader: "LogIn",
    loginButtonLabel: "LOGIN",
    resetPwdButtonLabel: "Forgot/Reset your password?",
    signUpLabel: "Register now",
    passwordChecklistLabel: "Your password must contain:",
    jurisdictionLabel: "JURISDICTION",
    seasonStartLabel: "START DATE",
    seasonEndLabel: "END DATE",
    manageProfileLabel: "Manage Profile",
    eServicePortal:"eServices Portals"
}

export const genericlabels={
    lblClose:"Close",
    lblOk:"Ok",
    lblCancel:"Cancel",
    lblError:"Error!"
}

export const verifyEmailLabels={
    header:"Registration Successful",
    message1:"Your account has been created successfully. Please check your email to verify your account.",
    btnSecondaryText:"Close",
    btnPrimaryText:"Ok"
}

export const verifiedRegistrationLabels={
    header:"Verification Completed",
    message1:"Your email address has been successfully verified",
    messageSd:"Your email address has been successfully verified.",
    message2NonRegistration:"Your email address has been successfully verified. You will be notified once your registration request is approved.",
    btnSecondaryText:"Close",
    btnPrimaryText:"Complete registration"
}

export const notVerifiedRegistrationLabels={
    header:"Verification expired",
    message1:"Email verification link expired",
   // message2:"Please re-send the verification request.",
    btnSecondaryText:"Close",
    btnPrimaryText:"Re-Verify"
}

export const emailSentLabels={
    header:"Re-verify Registration",
    message1:"Check your email and open the link we sent you to continue.",
    btnSecondaryText:"Close",
}

export const mapCenterRegistrationLabels={
    header:"Map Center Access",
    message1:"Your registration request is successfully submitted. You will be notified once your request is approved.",
    message2:"Registration request has been approved and completed",
    message3:"Registration request partially approved.",
    message4:"User registration verified successfully",
    message5:"Registration request rejected",
    message6: "User updated successfully",
    btnSecondaryText:"Close",
}

export const diversityRegistrationLabels={
    header:"Supplier Diversity Access",
    message1:"Your registration is successfully done.",
    btnSecondaryText:"Close",
}

export const resetSuccessLabels={
    header:"Reset Password Successful",
    message1:"You Successfully reset your Password!",
    btnSecondaryText:"Close",
}

export const resetFailedLabels={
    header:"Reset Password Failed",
    message1:"There is a problem reset your password!",
    btnSecondaryText:"Close",
}

export const OTPFailedLabels={
    header:"OTP Failed",
    message1:"There is a problem generating the OTP.",
    btnSecondaryText:"Close",
}

export const uploadLabels={
    header:"Upload",
    message1:"Are you sure you want to delete the file?",
    btnSecondaryText:"No",
    btnPrimaryText:"Yes"
}

export const aggrementEALabel={
    header:"Energy Assistance",
    message1:"All information provided through the Washington Gas Energy Assistance portal is the confidential information of Washington Gas Light Company and is not to be distributed to any other party without the express written permission of Washington Gas Light Company. All parties accessing this information should comply with all applicable laws covering data privacy (including, but not limited to, the Virginia Consumer Data Protection Act and the Maryland Online Data Privacy Act) as a condition of such access.",
    btnSecondaryText:"Close",
    btnPrimaryText:"Acknowledge",
    agreeText:"I agree",
    confText:"Confidential Information Disclaimer"
}

export const myProfileLabels={
    header:"My Profile",
    message1:"Profile data is updated successfully.",
    btnSecondaryText:"Close",
    deleteMessage: "Profile Deleted successfully."
}

export const SupportLabels={
    header:"Support",
    message1:"Support Details is updated successfully.",
    btnSecondaryText:"Close",
}

export const SupplierDiversityLabels = {
    header: "Update Email Address",
    message1: "You are about to update your email address. You will be automatically logged out after saving the changes. Do you want to proceed?",
    btnConfirm1: "Confirm",
    btnCancel: "Cancel",
    message2: "Company Information updated successfully. You will now be logged out. Please log in again with your new email.",
    btnConfirm2: "Acknowledge"
}